'use strict';

/* Given a popup window of width w, return the left edge offset in pixels to horizontally center the popup */
export const screenLeftCenter = async (w) => {
  var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
  var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  return ((width / 2) - (w / 2)) + dualScreenLeft;
}

/* Given a popup window of hieght h, return the top edge offset in pixels to vertically center the popup */
export const screenTopCenter = async (h) => {
  var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
  var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  return ((height / 2) - (h / 2)) + dualScreenTop;
}

/* determine screen size via js
*   args include small, small-only, medium, medium-only, large, large-only, xlarge
*   lack of '-only' implies '-and-up'
*   returns true for a match
*/
export const screenSizeMatches = async (screenSize) => {
  var mq = '';
  if (screenSize == 'small-only') {
    mq = 'screen and (max-width: 39.9375em)';
  } else if (screenSize == 'medium') {
    mq = 'screen and (min-width: 40em)';
  } else if (screenSize == 'medium-only') {
    mq = 'screen and (min-width: 40em) and (max-width: 63.9375em)';
  } else if (screenSize == 'large') {
    mq = 'screen and (min-width: 64em)';
  } else if (screenSize == 'large-only') {
    mq = 'screen and (min-width: 64em) and (max-width: 74.9375em)';
  } else if (screenSize == 'xlarge') {
    mq = 'screen and (min-width: 75em)';
  }
  return window.matchMedia(mq).matches;
}